var OCS = OCS || {};
OCS.BootFunctions = OCS.BootFunctions || {}; // Functions placed here will be ran at different points in the boot sequence
OCS.BootFunctions.application = OCS.BootFunctions.application || {};

OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Classes = OCS.WxBriefing.Classes || {};
OCS.WxBriefing.Live = OCS.WxBriefing.Live || {};
/**
 * SearchManager Class
 *
 * This class manages the Search Interface of the weather briefing page.
 *
 * @module UI
 * @submodule Managers
 * @class SearchManager
 * @constructor
 * @requires Mootools 1.6.0+
 *
 */
OCS.WxBriefing.Classes.SearchManager = new Class({
    Implements: [OCS.WxBriefing.Classes.SingletonManager],
    manager_name: 'SearchManager',
    temp_term: "",
    underlay: null,
    options: {
        escape_key_code: 27,
        search_results_to_display: 20,
        element: '.search',
        search_url: '/index.php/api/weather_briefing/search/q/{q}/format/json',
        search_results_container_id: 'desktop_search_results_container',
        search_results_menu_selector: '.search_results_menu',
        search_input_class: "search_input",
        search_input_container_id: "desktop_search_container",
        search_input_id: "search_input",
        search_input_placeholder: "Search",
        search_input_type: "search",
        search_timer: 1000
    },
    element: null,
    search_in_progress: false,
    bound_methods: {},
    search_req: null,
    found_entry_ids: [],
    fetch_timeout_term: '',
    fetch_timeout: null,
    init: function (op) {
        this.setOptions(op);
        this.bound_methods.search_callback = this.search_callback.bind(this);
        this.bound_methods.handle_keydown = this.handle_keydown.bind(this);
        this.bound_methods.on_search_success = this.on_search_success.bind(this);
        this.bound_methods.on_url_state_change = this.on_url_state_change.bind(this);
        var am = OCS.Functions.get_ajax_manager();
        if (OCS.Constants.DEBUG) {
            console.log('OCS.WxBriefing.Live.UI.SearchManager initialized');
        }
        OCS.Functions.get_ajax_manager();
        this.search_req = am.request("search", {
            url: this.options.search_url,
            dataType: "json",
            corsRequest: false,
            method: "GET",
            onSuccess: this.bound_methods.on_search_success
        });
        this.run_fetch = function(search) {
            var search_term = search.trim();
            if(this.search_req && this.search_req.running || this.search_in_progress) {
                // We have an active search running, lets change what we are searching for
                if(search_term !== this.temp_term){
                    this.fetch(search);
                }
            } else {
                // No active search running, lets set a timeout, before activating it
                if(search_term !== this.temp_term && search_term !== this.fetch_timeout_term) {
                    if (this.fetch_timeout) {
                        clearTimeout(this.fetch_timeout);
                    }
                    this.fetch_timeout_term = search_term;
                    this.fetch_timeout = setTimeout(function () {
                        this.fetch(this.fetch_timeout_term);
                        this.fetch_timeout_term = null;
                    }.bind(this), this.options.search_timer);
                }
            }
        }.bind(this);

        this.underlay = new OCS.WxBriefing.Classes.MenuUnderlay();
    },
    start: function () {
        this.draw();
    },
    draw: function () {
        var container = document.id(this.options.search_input_container_id);
        if (!this.element && container) {
            this.element = new Element('input', {
                'class': this.options.search_input_class,
                'id': this.options.search_input_id,
                'type': this.options.search_input_type,
                'placeholder': this.options.search_input_placeholder
            }).inject(container);
            this.element.addEvent('keyup', this.bound_methods.search_callback);
            document.id(window).addEvent('keydown', this.bound_methods.handle_keydown);
        }
    },
    clear_search: function () {
        this.temp_term = '';
        this.element.set('value', '');
        if(this.search_req && this.search_req.running) {
            this.search_req.cancel();
        }
    },

    search_callback: function (event) {
        var search_term = this.element.get('value');
        if (search_term.length > 2) {
            this.run_fetch(search_term);
        } else {
            if (this.search_in_progress) {
                this.finish_search();
            }
        }
    },
    fetch: function (search_term) {
        search_term = search_term.trim();
        if (this.temp_term !== search_term) {
            if (!this.search_in_progress) {
                this.search_in_progress = true;
                var um = OCS.WxBriefing.Functions.get_url_manager();
                um.addEvent(um.options.url_pending_state_change_event, this.bound_methods.on_url_state_change);
            }
            this.temp_term = search_term;
            if (typeof (gtag) !== 'undefined' && gtag) {
                gtag('event', 'pageview', { 'query': search_term });
            }
            OCS.WxBriefing.Live.UI.send_analytic_event({'category': 'Search', 'action': 'Search', 'label': search_term});
            if(this.search_req.running) {
                this.search_req.cancel();
            }
            this.search_req.set_url_keys({q: search_term}); // Set the key value for the url replace function to work off of for this search term
            this.search_req.send({data: {q: search_term}});
        }
    },
    process_for_display_results: function (data) {
        var results = [];
        if (data.length) {
            this.found_entry_ids = [];
            data.each(function (item, idx) {
                if (idx < this.options.search_results_to_display) {
                    item.title = item.title.trunc(30, true);
                    item.product_desc = unescape(item.product_description).replace(/(<([^>]+)>)/ig, "").trunc(60, true);
                    results.push(item);
                    this.found_entry_ids.push(item.entry_id);
                } else {
                    return false;
                }
            }.bind(this));
        }
        return {'results': results};
    },
    hide_results: function () {
        var drop_window = new OCS.WxBriefing.Classes.DropdownWindow();
        drop_window.hide();
        this.underlay.hide();
    },
    handle_keydown: function (event) {
        if (event.code === this.options.escape_key_code) {
            event.stop();
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
        }
    },
    on_click_product: function (event, target) {
        OCS.WxBriefing.Live.UI.send_analytic_event({'category': 'Search', 'action': 'Preview', 'entry_id': target.get('data-entry_id')});

    },
    on_search_success: function (response) {
        OCS.WxBriefing.Functions.get_ui_menu().reset_menu({'search_results_open': true});
        var tm = OCS.WxBriefing.Functions.get_template_manager();
        var html = tm.get_html('search_results', this.process_for_display_results(response.json));
        var drop_window = new OCS.WxBriefing.Classes.DropdownWindow();
        var search_elements = Elements.from(html);
        drop_window.position(this.element).content(search_elements).show();
        drop_window.addEvent('click_product', this.on_click_product.bind(this));
        this.underlay.show();
    },
    on_url_state_change: function (deltas) {
        Object.values(deltas).each(function (panel) {
            if (panel && panel.entry_id && this.found_entry_ids.contains(panel.entry_id)) {
                this.finish_search({entry_id: panel.entry_id});
            }
        }.bind(this));
    },
    finish_search: function (data) {
        if (this.search_in_progress) {
            if (data && data.entry_id) {
                OCS.WxBriefing.Live.UI.send_analytic_event({'category': 'Search', 'action': 'Found', 'entry_id': data.entry_id});
            } else {
                OCS.WxBriefing.Live.UI.send_analytic_event({'category': 'Search', 'action': 'Cancel'});
            }
            this.hide_results();
            this.clear_search();
            this.search_in_progress = false;
            var um = OCS.WxBriefing.Functions.get_url_manager();
            um.removeEvent(um.options.url_pending_state_change_event, this.bound_methods.on_url_state_change);
        }
    },
    destroy: function () {
        this.search_req.removeEvent('success', this.bound_methods.on_search_success);
        this.search_req.cancel();
        this.search_req = null;
        this.underlay = null;
    }
}); // OCS.WxBriefing.Live.UI.SearchManager
